<script lang="ts">
    import Vue from "vue";
    import { Component } from 'vue-facing-decorator';
    import { WeightsSetDependenciesViewerViewModel } from "@Criteria/Weights/Components/WeightsSetDependenciesViewer";
    import { DependentEntityInfo } from "@common/types";
    import { dynamicUiRoutes } from "@common/dynamicUiRoutes";

    @Component({
        props: {
            viewModel: {
                type: Object,
                required: true
            }
        }
    })
    export default class WeightsSetDependenciesViewer extends Vue
    {
        get vm(): WeightsSetDependenciesViewerViewModel { return this.$props.viewModel as WeightsSetDependenciesViewerViewModel; }
        get opened(): boolean { return this.vm?.opened ?? false; }

        get initialized(): boolean { return this.vm.initialized; }
        get weightsSetName(): string { return this.vm.weightsSetName; }
        get hasDependants(): boolean { return this.vm.hasDependants; }
        get dependenciesCount(): number { return this.vm.dependenciesCount; }
        get weightedScores(): DependentEntityInfo[] { return this.vm.weightedScores; }

        url_EditWeightedScorePage(e: DependentEntityInfo)
        {
            return dynamicUiRoutes.Criteria_EditWeightedScorePage2(this.$route, e.WorkspaceId, e.TchProjectId, Number.parseInt(e.Id))
        }

        close()
        {
            this.vm.close();
        }
    }
</script>

<template>
    <div class="modal-mask" v-if="opened">
        <div class="modal-wrapper">
            <div class="modal-dialog modal-lg modal-dialog-scrollable">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Weights set dependencies</h5>
                        <button type="button" class="close" @click="close">&times;</button>
                    </div>
                    <div class="modal-body">
                        <h3 v-if="!initialized"><i class="fa fa-spinner fa-spin"></i> Checking dependencies... </h3>
                        <div v-if="initialized">
                            <div class="alert alert-warning text-dark" role="alert">
                                <p>
                                    The weights set '<strong>{{weightsSetName}}</strong>' is used in <strong>{{dependenciesCount}}</strong> places.
                                </p>
                            </div>
                            <div>
                                <div class="card" v-if="weightedScores.length > 0">
                                    <div class="card-header">
                                        Weighted scores (<span>{{weightedScores.length}}</span>)
                                    </div>
                                    <ul class="list-group list-group-flush">
                                        <li class="list-group-item" v-for="ws in weightedScores" :key="ws.Id">
                                            <a class="text-primary" v-sanitizedHref="url_EditWeightedScorePage(ws)">{{ws.Name}}</a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" @click="close" class="btn btn-outline-secondary">Close</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>
</style>